import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ContactDataService } from 'src/app/modules/user-profile/services/contact-data-service';
import { ContactVerificationService } from 'src/app/modules/user-profile/services/contact-verification-service';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-contact-verification-introduction',
    templateUrl: './contact-verification-introduction.component.html',
    styleUrls: ['./contact-verification-introduction.component.css'],
    imports: []
})
export class ContactVerificationIntroductionComponent implements OnInit {
  private router = inject(Router);
  cService = inject(ContactVerificationService);
  cDataService = inject(ContactDataService);

  routeFlag = false;
  
  ngOnInit(): void {
    if (environment.debug) console.log('In ContactVerificationIntroductionComponent.ngOnInit(): this.cService.tokenDtls=',this.cService.tokenDtls);
  }
  updatestepcount(isnext) {    
    if (isnext) {
      this.cService.setStep('Personal Email');
      this.cService.stepCount++;      
    }
    else {
      this.cService.setStep('Introduction');
      this.cService.stepCount--;
    }
  }
}
